module.exports = "<p>\n  group-report works!\n</p>\n"